module.exports = __webpack_public_path__ + "static/media/bgBeranda.fd1c9f01.jpg";